"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var GitHub = require("react-icons/lib/go/mark-github");
var react_redux_1 = require("react-redux");
var Button_1 = require("../component/Button");
var FacebookButton_1 = require("../component/FacebookButton");
var Feature_1 = require("../component/Feature");
var Link_1 = require("../component/Link");
var Screenshots_1 = require("../component/Screenshots");
var TwitterButton_1 = require("../component/TwitterButton");
var config_1 = require("../config");
var authentication_1 = require("../redux/authentication");
require("./style/SignIn.css");
var SignIn = /** @class */ (function (_super) {
    __extends(SignIn, _super);
    function SignIn() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SignIn.prototype.render = function () {
        return (React.createElement("div", { className: "SignIn-container" },
            React.createElement("div", { className: "SignIn-main" },
                React.createElement("div", { className: "SignIn-title-container" },
                    React.createElement("img", { className: "SignIn-icon", src: require("../images/icon.svg") }),
                    React.createElement("div", { className: "SignIn-title" }, config_1.default.name),
                    React.createElement("div", { className: "SignIn-short-description" }, "Todo management tools for software engineers")),
                React.createElement(Button_1.default, { className: "SignIn-button", onClick: this.props.signIn },
                    React.createElement(GitHub, null),
                    " Sign in with GitHub")),
            React.createElement("div", { className: "SignIn-description" },
                React.createElement("div", { className: "SignIn-overview" },
                    React.createElement("div", { className: "SignIn-overview-title" }, "Make your todos done"),
                    React.createElement("div", { className: "SignIn-overview-text" }, "code2d is a set of todo management tools. Keep you productive and learning new things everyday!")),
                React.createElement("div", { className: "SignIn-features" },
                    React.createElement(Feature_1.default, { title: "Manage everything to do", image: require("../images/tasks.svg") }, "Manage tasks to do, articles to read, videos to watch, and books to read in one place."),
                    React.createElement(Feature_1.default, { title: React.createElement(Link_1.default, { colored: true, href: config_1.default.chrome.extensionUrl }, "Chrome browser support"), image: require("../images/chrome.svg") },
                        "Install ",
                        React.createElement(Link_1.default, { colored: true, href: config_1.default.chrome.extensionUrl }, "the Chrome extension"),
                        ". It allows you to add artciles, videos, and books shown in current tabs to todo lists by one click."),
                    React.createElement(Feature_1.default, { title: "Built-in pomodoro timer", image: require("../images/timer.svg") }, "Use pomodoro technique to be productive and make your work done faster."),
                    React.createElement(Feature_1.default, { title: "Pursue trends", image: require("../images/flame.svg") }, "Don't miss any trending article, video, or book. Update yourself with the latest information."),
                    React.createElement(Feature_1.default, { title: "Sync data over devices", image: require("../images/sync.svg") }, "Sync your tasks and stocked articles, videos, and books over your desktops, laptops and smartphones."),
                    React.createElement(Feature_1.default, { title: "Focus on engineering", image: require("../images/focus.svg") }, "Keep other things away and grow yourself."))),
            React.createElement(Screenshots_1.default, null),
            React.createElement("div", { className: "SignIn-footer" },
                React.createElement("div", { className: "SignIn-social-buttons" },
                    React.createElement(FacebookButton_1.default, null),
                    React.createElement(TwitterButton_1.default, null)),
                React.createElement(Link_1.default, { href: config_1.default.feedbackUrl }, "Feedback"),
                React.createElement(Link_1.default, { href: config_1.default.repositoryUrl }, "GitHub"),
                React.createElement(Link_1.default, { href: "/terms_of_use.pdf" }, "Terms of Use"),
                React.createElement(Link_1.default, { href: "/privacy_policy.pdf" }, "Privacy Policy"))));
    };
    return SignIn;
}(React.Component));
exports.default = react_redux_1.connect(function (_a) {
    var authentication = _a.authentication;
    return authentication;
}, authentication_1.actionCreators)(SignIn);



//////////////////
// WEBPACK FOOTER
// ./src/container/SignIn.tsx
// module id = 628
// module chunks = 0